/**
 * @generated SignedSource<<685324005536c0de7faf47b1342079bf>>
 * @relayHash bc7b99240d9187d11ae7b905f77c6810
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dd5c5052a127803b509014898bc3c9365eb873b77c1d9bddd5e2aba3dabd6f09

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type removeApprover_softwareReleasesApproversMutation$variables = {
  approverAri: string;
};
export type removeApprover_softwareReleasesApproversMutation$data = {
  readonly jira: {
    readonly deleteJiraVersionApprover: {
      readonly deletedApproverId: string | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type removeApprover_softwareReleasesApproversMutation$rawResponse = {
  readonly jira: {
    readonly deleteJiraVersionApprover: {
      readonly deletedApproverId: string | null | undefined;
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type removeApprover_softwareReleasesApproversMutation = {
  rawResponse: removeApprover_softwareReleasesApproversMutation$rawResponse;
  response: removeApprover_softwareReleasesApproversMutation$data;
  variables: removeApprover_softwareReleasesApproversMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "approverAri"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "approverAri"
          }
        ],
        "concreteType": "JiraVersionDeleteApproverPayload",
        "kind": "LinkedField",
        "name": "deleteJiraVersionApprover",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "kind": "ScalarField",
            "name": "deletedApproverId"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "removeApprover_softwareReleasesApproversMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "removeApprover_softwareReleasesApproversMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "dd5c5052a127803b509014898bc3c9365eb873b77c1d9bddd5e2aba3dabd6f09",
    "metadata": {},
    "name": "removeApprover_softwareReleasesApproversMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "c4ddb7a4c6fdd0197fc36106f5bdabcb";

export default node;
